import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {SlickGridComponent} from "./slick-grid.component";
import { TranslateModule } from '@ngx-translate/core';

import {UniversalListComponent} from "../shared/components/universal-list.component/universal-list.component";
import {FormsModule} from "@angular/forms";

@NgModule({
    imports: [CommonModule, TranslateModule.forChild(), FormsModule],
    declarations: [SlickGridComponent, UniversalListComponent],
    exports: [SlickGridComponent, UniversalListComponent]
})
export class SlickGridModule {

}



// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.module.ts